<template>
  <div class="terms__content">
   <p>
     {{$t('terms.text[0]', {hostname: hostname})}}
   </p>

    <p>
      {{$t('terms.text[1]')}}
      <a :href="'mailto:' + supportEmail">{{supportEmail}}</a>.
    </p>

    <p>{{$t('terms.text[2]')}}</p>

    <p>{{$t('terms.text[3]')}}</p>

    <h3>{{$t('terms.list[0].title')}}</h3>
    <p>{{$t('terms.list[0].text')}}</p>

    <h3>{{$t('terms.list[1].title')}}</h3>
    <p>{{$t('terms.list[1].text[0]')}}</p>
    <p>{{$t('terms.list[1].text[1]')}}</p>
    <p>{{$t('terms.list[1].text[2]')}}</p>
    <p>{{$t('terms.list[1].text[3]')}}</p>
    <p>{{$t('terms.list[1].text[4]')}}</p>

    <h3>{{$t('terms.list[2].title')}}</h3>
    <p>{{$t('terms.list[2].text[0]')}}</p>
    <p>{{$t('terms.list[2].text[1]')}}</p>

    <h3>{{$t('terms.list[3].title')}}</h3>
    <p>{{$t('terms.list[3].text[0]')}}</p>
    <p>{{$t('terms.list[3].text[1]')}}</p>
    <ul>
      <li>{{$t('terms.list[3].clarification[0]')}}</li>
      <li>{{$t('terms.list[3].clarification[1]')}}</li>
      <li>{{$t('terms.list[3].clarification[2]')}}</li>
      <li>{{$t('terms.list[3].clarification[3]')}}</li>
      <li>{{$t('terms.list[3].clarification[4]')}}</li>
      <li>{{$t('terms.list[3].clarification[5]')}}</li>
    </ul>

    <h3>{{$t('terms.list[4].title')}}</h3>
    <p>{{$t('terms.list[4].text[0]')}}</p>
    <p>
      {{$t('terms.list[4].text[1]')}}
      <a :href="'mailto:' + supportEmail">{{supportEmail}}</a>.
    </p>
    <p>{{$t('terms.list[4].text[2]')}}</p>
    <p>{{$t('terms.list[4].text[3]')}}</p>

    <h3>{{$t('terms.list[5].title')}}</h3>
    <p>{{$t('terms.list[5].text')}}</p>


    <h3>{{$t('terms.list[6].title')}}</h3>
    <p>{{$t('terms.list[6].text')}}</p>

    <h3>{{$t('terms.list[7].title')}}</h3>
    <p>{{$t('terms.list[7].text[0]')}}</p>
    <p>{{$t('terms.list[7].text[1]')}}</p>
    <p>{{$t('terms.list[7].text[2]')}}</p>
    <ul>
      <li>{{$t('terms.list[7].clarification[0]')}}</li>
      <li>{{$t('terms.list[7].clarification[1]')}}</li>
      <li>{{$t('terms.list[7].clarification[2]')}}</li>
      <li>{{$t('terms.list[7].clarification[3]')}}</li>
      <li>{{$t('terms.list[7].clarification[4]')}}</li>
    </ul>
    <p>{{$t('terms.list[7].text[3]')}}</p>

    <h3>{{$t('terms.list[8].title')}}</h3>
    <p>{{$t('terms.list[8].text[0]')}}</p>
    <p>{{$t('terms.list[8].text[1]')}}</p>
    <p>{{$t('terms.list[8].text[2]')}}</p>
    <p>{{$t('terms.list[8].text[3]')}}</p>
    <p>{{$t('terms.list[8].text[4]')}}</p>
    <p>{{$t('terms.list[8].text[5]')}}</p>

    <h3>{{$t('terms.list[9].title')}}</h3>
    <p>{{$t('terms.list[9].text[0]')}}</p>
    <p>{{$t('terms.list[9].text[1]')}}</p>
    <p>{{$t('terms.list[9].text[2]')}}</p>
    <p>{{$t('terms.list[9].text[3]')}}</p>

    <h3>{{$t('terms.list[10].title')}}</h3>
    <p>{{$t('terms.list[10].text')}}</p>

    <h3>{{$t('terms.list[11].title')}}</h3>
    <p>{{$t('terms.list[11].text')}}</p>

    <h3>{{$t('terms.list[12].title')}}</h3>
    <p>{{$t('terms.list[12].text')}}</p>

    <h3>{{$t('terms.list[13].title')}}</h3>
    <p>{{$t('terms.list[13].text')}}</p>

    <h3>{{$t('terms.list[14].title')}}</h3>
    <p>{{$t('terms.list[14].text')}}</p>

    <h3>{{$t('terms.list[15].title')}}</h3>
    <p>{{$t('terms.list[15].text')}}</p>

    <h3>{{$t('terms.list[16].title')}}</h3>
    <p>{{$t('terms.list[16].text')}}</p>

    <h3>{{$t('terms.list[17].title')}}</h3>
    <p>{{$t('terms.list[17].text[0]')}}
      <a :href="'mailto:' + supportEmail">{{supportEmail}}</a>
      {{$t('terms.list[17].text[1]')}}</p>
    <ul>
      <li>{{$t('terms.list[17].clarification[0]')}}</li>
      <li>{{$t('terms.list[17].clarification[1]')}}</li>
      <li>{{$t('terms.list[17].clarification[2]')}}</li>
      <li>{{$t('terms.list[17].clarification[3]')}}</li>
      <li>{{$t('terms.list[17].clarification[4]')}}</li>
      <li>{{$t('terms.list[17].clarification[5]')}}</li>
    </ul>

    <h3>{{$t('terms.list[18].title')}}</h3>
    <p>{{$t('terms.list[18].text[0]')}}</p>
    <p>{{$t('terms.list[18].text[1]')}}</p>

    <h3>{{$t('terms.list[19].title')}}</h3>
    <p>{{$t('terms.list[19].text[0]', {supportEmail: supportEmail})}}</p>
    <p>{{$t('terms.list[19].text[1]')}}</p>

  </div>
</template>

<script>
export default {
  name: "terms-of-services",

  computed: {
    hostname() {
      return window.location.hostname;
    },
  },

  data() {
    return {
      supportEmail: 'support@' + window.location.hostname,
    }
  },
}
</script>

<style scoped>

</style>
